<template>
  <s-page class="max-w-2xl mx-auto" v-if="isDataLoaded">
    <invoice-list />
  </s-page>
</template>

<script>
import SPage from '@/components/SPage'
import InvoiceList from '@/components/InvoiceList'
import { mapState } from 'vuex'

export default {
  name: 'Invoicing',
  components: {
    InvoiceList,
    SPage
  },
  computed: {
    ...mapState('config', ['isDataLoaded'])
  }
}
</script>
